import 'isomorphic-fetch';

import { receiveGlobalMeta, getCacheBuster, resetSelectedItem } from 'Actions/MetaActions';
import {
	getLoadingBehavior, shouldNotUpdateState,
	updatePagesResult, fetchSuccess
} from 'Actions/InfiniteScrollActions';
import {
	setLastGlobalAction, setGlobalNotification, backInHistory,
	refreshPage, getFetchConfig
} from 'Actions/GlobalMetaActions';
import { addPhoto } from 'Actions/PhotoGalleryActions';
import { trackGAEvent } from 'Actions/adsActions';
import {
	showGlobalLoading,
	hideGlobalLoading,
	displayNotification
} from 'Actions/UiActions'
import { mapLoadingBehaviour, getPageSize } from 'Actions/UserSettingsActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';

import {
	requestThread,
	receiveThread,
	failedThread
} from 'Common/actions/ThreadviewActions';

export * from 'Common/actions/ThreadviewActions';

export function addPhotoGalleryItems( response ) {
	let attachments = response.entities.attachments;
	return ( dispatch ) => {
		response.result.attachments.forEach( ( id ) => {
			let attachment = attachments[ id ];
			dispatch(
				addPhoto( {
					id: id,
					src: attachment.href,
					thumbnail: attachment.href_thumbnail ? attachment.href_thumbnail : attachment.href,
					w: 0,
					h: 0,
					postId: attachment.post
				} )
			);
		} );
	};
}

export function fetchThread( thread, cacheBust = false ) {

	return function( dispatch, getState ) {
		thread.loadingBehavior = getLoadingBehavior( getState, thread.id, "thread", thread.page, ( thread.postid ? true : thread.forceRefresh) );

		if( shouldNotUpdateState( getState, thread ) ) {
			dispatch( updatePagesResult( thread.page || 1 ) );
			return null;
		}

		dispatch( requestThread( thread ) );

		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		let userID = state.ustate.id ? state.ustate.id : 0;
		let goto = thread.postid ? `&goto=true&postid=${thread.postid}` : `&id=${thread.id}`;
		let page = thread.postid ? '' : ( thread.page ? `&page=${thread.page}` : `&page=0` ); // if we have a postid skip the page

		// Avoid Cache if cacheBust is required
		let fetchConfig = dispatch( getFetchConfig( cacheBust ) ),
			cacheBustQueryString = '&_=' + ( cacheBust ? cacheBust : ( getCacheBuster( getState ) || 0 ) ),
			lb = mapLoadingBehaviour( state.ui.userSettings.loadingBehavior ),
			page_size = dispatch( getPageSize() );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=topic${ goto }&pagesize=${ page_size }${ page }&lb=${ lb }${ cacheBustQueryString }`, fetchConfig ).then( ( response ) => {
			if( !response.ok ) {
				try {
					response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, response );
					} ).catch( () => {
						setGlobalNotification( dispatch, {}, response );
					} );
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}

				dispatch( failedThread( thread, 'Bad response from server' ) );
				dispatch( backInHistory() );

			} else {
				response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, { ok: true } );

						let other = Object.assign( {}, { page: json.post.meta.page }, json.post ? json.post.meta : {} );

						let result = responseNormalizer( json, thread.page, other );

						thread.id = result.threadid;
						thread.page = json.post.meta.page;
						const forumTitle = state.topifyPresets.forumSite.f_title;

						dispatch( receiveGlobalMeta( json.post.meta, result.entities.topics[ result.result.topics[ 0 ] ].title, forumTitle ) );

						dispatch( updateUstate( json, result ) );

						dispatch( addPhotoGalleryItems( result ) );
						dispatch( fetchSuccess( result.threadid, "thread", result.page, result.totalPages, thread.loadingBehavior ) );
						dispatch( receiveThread( thread, result ) );
					}
				)
			}
		} ).then( () => {
			setLastGlobalAction( 'thread', thread );

		} ).catch( ( error ) => {
			setGlobalNotification( dispatch, {}, error );
			dispatch( failedThread( thread, 'Bad response from server' ) );
			dispatch( backInHistory() );
		} );
	}
}

/**
 *
 * @param postsId
 * @param actionState bool true: delete | false: undelete
 * @returns {Function}
 */
export function deletePosts( postsId, actionState = false ) {
	return function( dispatch, getState ) {
		topifyConsole.log( 'Delete Posts', postsId );
		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0,
			newState = actionState ? "1" : "-1";

		let postids = [];
		postsId.forEach( function( postid ) {
			postids.push( 'relpostid[]=' + postid );
		} );
		postids = postids.join( '&' );

		let moreData = `&req=post&state=${ newState }&type=moderate&action=delete`;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', postids ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }${ moreData }`, fetchConfig ).then( ( response ) => {
				if( !response.ok ) {
					try {
						response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, response );
						} ).catch( () => {
							setGlobalNotification( dispatch, {}, response );
						} );
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

					dispatch( failedThread( thread, 'Bad response from server' ) );
					dispatch( backInHistory() );

				} else {
					response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, { ok: true } );
							if( json.state ) {
								let count = json.result.postid.length,
									message = `${ count } post${ count === 1 ? ' was' : 's were' } ${ json.result.isDeleted ? 'deleted' : 'undeleted' }`;
								displayNotification( 'success', message );

								if( state.meta.permissions && state.meta.permissions.candeleteposts ) {
									// is Mod
									// Record the Google Analytics event and for the forum.
									dispatch( trackGAEvent( true, ( actionState ? 'modDeletePosts' : 'modUndeletePosts' ), 'moderatorAction', 'topic' ) );
								} else {
									// is regular user
									// Record the Google Analytics event and for the forum.
									dispatch( trackGAEvent( true, 'deletePost', 'userAction', 'creation' ) );
								}
							} else {
								displayNotification( 'warning', 'Some error happened. Try again.' );
							}
						}
					)
				}
			}
		).then( () => {
			dispatch( refreshPage() );
			dispatch( hideGlobalLoading() );

		} ).catch( ( error ) => {
			dispatch( hideGlobalLoading() );
			setGlobalNotification( dispatch, {}, error );
			dispatch( failedThread( thread, 'Bad response from server' ) );
			dispatch( backInHistory() );
		} );
	};
}

export function doPollVote( vote ) {
	return function( dispatch, getState ) {
		const state = getState(),
			url = state.topifyPresets.forumSite.url + '?v=3.0&ajax=1&req=post&uid=' + state.ustate.id,
			voteBody = 'type=vote&pollid=' + vote.pollID + '&topic=' + vote.topic + '&votes=' + vote.votes;

		const config = dispatch( getFetchConfig( true, 'POST', voteBody ) );

		return fetch( url, config ).then( ( response ) => {
			if( !response.ok ) {
				try {
					response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, response );
					} ).catch( () => {
						setGlobalNotification( dispatch, {}, response );
					} );
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}

			} else {
				response.json().then( ( json ) => {
					dispatch( refreshPage() );
					displayNotification( 'info', 'You have voted' );
					// Record the Google Analytics event.
					dispatch( trackGAEvent( false, 'pollVote', 'userAction', 'creation' ) );
				} )
			}
		} );
	};
}

export function markAsRead( itemIds, type ) {
	return function( dispatch, getState ) {
		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0;

		topifyConsole.log( 'Mark ' + type + ' as read', itemIds );

		if( !itemIds || !type ) {
			return false;
		}

		let moreData = [],
			analyticsEvent = null;

		switch( type ) {
			case 'forums':
				moreData.push( `forumid=${ itemIds }` );
				analyticsEvent = 'forumMarkedRead';
				break;

			case 'topics':
				itemIds = isNaN( itemIds ) && itemIds.length ? itemIds : [ itemIds ];
				itemIds.forEach( function( item_id ) {
					moreData.push( 'topicid[]=' + item_id );
				} );
				analyticsEvent = 'topicMarkedRead';
				break;

			case 'announcement':
				moreData.push( `type=markread` );
				moreData.push( `announcementid=${ itemIds }` );
				analyticsEvent = 'announcementMarkedRead';
				break;
		}
		moreData = moreData.join( '&' );

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		if( type !== 'announcement' ) {
			dispatch( showGlobalLoading( 'Processing' ) );
		}

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post&type=markread`, fetchConfig ).then( ( response ) => {
				if( !response.ok ) {
					try {
						response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, response );
						} ).catch( () => {
							setGlobalNotification( dispatch, {}, response );
						} );
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

				} else {
					response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, { ok: true } );

							if( analyticsEvent ) {
								// Record the Google Analytics event.
								dispatch( trackGAEvent( false, analyticsEvent, 'userAction', 'consumption' ) );
							}
							if( type !== 'announcement' ) {
								dispatch( resetSelectedItem() );
								dispatch( refreshPage() );
								dispatch( hideGlobalLoading() );
							}

							displayNotification( 'info', 'Successfully marked as read', { force: true, timeout: 1500 } );
						}
					);
				}
			}
		).catch( ( error ) => {
			dispatch( hideGlobalLoading() );
			setGlobalNotification( dispatch, {}, error );
		} );
	};
}

export function reportPost( postId ) {

	return function( dispatch, getState ) {
		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0;

		topifyConsole.log( 'Reporting Post', postId );

		if( !postId ) {
			return false;
		}

		let moreData = "relpostid=" + postId;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post&type=report`, fetchConfig ).then( ( response ) => {
				if( !response.ok ) {
					try {
						response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, response );
						} ).catch( () => {
							setGlobalNotification( dispatch, {}, response );
						} );
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

				} else {
					response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, { ok: true } );
							// Record the Google Analytics event.
							dispatch( trackGAEvent( false, "postReported", 'userAction', 'consumption' ) );
							displayNotification( 'info', 'Post successfully reported' );
						}
					);
				}
			}
		).catch( ( error ) => {
			dispatch( hideGlobalLoading() );
			setGlobalNotification( dispatch, {}, error );
		} );
	};
}



// WEBPACK FOOTER //
// ./src/actions/ThreadviewActions.js